// Shared state for receipt functionality
import { renderReceiptView } from './receiptView.mjs';

// Store selected items state
export let selectedItems = {};

// Track current view data for history navigation
export let currentExpense = null;
export let currentParticipants = null;
export let selectionHistoryStatePushed = false;

// Reset selected items
export function resetSelectedItems() {
    selectedItems = {};
}

// Set selected item quantity
export function setSelectedItem(index, quantity) {
    selectedItems[index] = quantity;
}

// Get total selected count
export function getTotalSelectedCount() {
    return Object.values(selectedItems).reduce((a, b) => a + b, 0);
}

// Update current view data
export function setCurrentView(expense, participants) {
    currentExpense = expense;
    currentParticipants = participants;
}

// Handle back button to cancel selection
window.addEventListener('popstate', (event) => {
    // If we have pushed a selection state, and the pop event happens
    // (meaning we likely went back to valid state, or forward to selection state)
    // We strictly want to handle "Back cancels selection".

    // If we were in selection mode (pushed=true) and now we are not (state doesn't have it),
    // then clear selection.
    // Or if we just trust our tracking: if pushed was true, and we popped, we should reset.
    if (selectionHistoryStatePushed) {
        // Double check if we are still effectively "in" selection mode according to history?
        // If event.state has selectionMode, we went FORWARD into selection.
        // If event.state is null/undefined (or different), we went BACK out of selection.
        const isInSelectionState = event.state && event.state.selectionMode;

        if (!isInSelectionState) {
            selectionHistoryStatePushed = false;
            selectedItems = {};
            // Only re-render if we are likely still on the receipt view
            if (currentExpense && document.getElementById('receipt-container')) {
                renderReceiptView(currentExpense, currentParticipants, false);
            }
        }
    }
});
